'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.makeBatchActions = makeBatchActions;

var _fsa = require('@zaibot/fsa');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeBatchActions(name) {
    let res = {
        APPLY: (0, _fsa.Action)((0, _utils.internal)('BATCH/APPLY_' + name.toUpperCase())),
        CREATE: (0, _fsa.Action)((0, _utils.internal)('BATCH/CREATE_' + name.toUpperCase())),
        CREATE_CANCEL: (0, _fsa.Action)((0, _utils.internal)('BATCH/CREATE_' + name.toUpperCase() + '_CANCEL')),
        CREATE_CONTINUE: (0, _fsa.Action)((0, _utils.internal)('BATCH/CREATE_' + name.toUpperCase() + '_CONTINUE')),
        DELETE: (0, _fsa.Action)((0, _utils.internal)('BATCH/DELETE_' + name.toUpperCase())),
        DELETE_CANCEL: (0, _fsa.Action)((0, _utils.internal)('BATCH/DELETE_' + name.toUpperCase() + '_CANCEL')),
        DELETE_CONTINUE: (0, _fsa.Action)((0, _utils.internal)('BATCH/DELETE_' + name.toUpperCase() + '_CONTINUE')),
        READ: (0, _fsa.Action)((0, _utils.internal)('BATCH/READ_' + name.toUpperCase())),
        READ_CANCEL: (0, _fsa.Action)((0, _utils.internal)('BATCH/READ_' + name.toUpperCase() + '_CANCEL')),
        READ_CONTINUE: (0, _fsa.Action)((0, _utils.internal)('BATCH/READ_' + name.toUpperCase() + '_SUCCESS')),
        RESET: (0, _fsa.Action)((0, _utils.internal)('BATCH/RESET_' + name.toUpperCase())),
        UPDATE: (0, _fsa.Action)((0, _utils.internal)('BATCH/UPDATE_' + name.toUpperCase())),
        UPDATE_CANCEL: (0, _fsa.Action)((0, _utils.internal)('BATCH/UPDATE_' + name.toUpperCase() + '_CANCEL')),
        UPDATE_CONTINUE: (0, _fsa.Action)((0, _utils.internal)('BATCH/UPDATE_' + name.toUpperCase() + '_CONTINUE'))
    };
    let all = [res.APPLY, res.CREATE, res.CREATE_CANCEL, res.CREATE_CONTINUE, res.DELETE, res.DELETE_CANCEL, res.DELETE_CONTINUE, res.READ, res.READ_CANCEL, res.READ_CONTINUE, res.RESET, res.UPDATE, res.UPDATE_CANCEL, res.UPDATE_CONTINUE];
    return (0, _extends3.default)({}, res, { all: all });
}
//# sourceMappingURL=makeBatchActions.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/batch/makeBatchActions.js